import { useEffect, useState } from "react"
import Cookies from "universal-cookie"

const COOKIE_NAME = "__Secure-Session"
const COOKIE_DOMAIN_UNSET = process.env.GATSBY_IONQ_SESSION_COOKIE_DOMAIN_UNSET
const IONQ_API_BASE_URL = process.env.GATSBY_IONQ_API_BASE_URL

const cookies = new Cookies()
const cookieOpts = {
  domain: ".ionq.com",
  path: "/",
  secure: true,
  httpOnly: false,
  sameSite: "none",
}
if (COOKIE_DOMAIN_UNSET) delete cookieOpts.domain

async function getUserData(token) {
  const url = new URL("/v0.3/users/me", IONQ_API_BASE_URL)
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (response.ok) return response.json()
  return null
}

export default function useSessionCookie() {
  const [session, setSession] = useState({ isLoading: true })

  useEffect(() => {
    const token = cookies.get(COOKIE_NAME, cookieOpts)
    if (!token) return

    // verify the token
    const invalidateSession = () => setSession({ isLoading: false })
    cookies.addChangeListener(invalidateSession)
    getUserData(token)
      .then(user => setSession({ isLoading: false, user }))
      .catch(console.error)

    // housekeeping
    return () => {
      cookies.removeChangeListener(invalidateSession)
    }
  }, [setSession])

  function removeSession() {
    cookies.remove(COOKIE_NAME, cookieOpts)
  }

  return [session, removeSession]
}
